import styled from 'styled-components';

const RelatedStyle = styled.section`
	--relatedTopBottomContentDistance: var(--sp9x);
	--sliderIconsDistance: var(--sp2x);
	--sliderIconSize: var(--sp5x);
	--swiperSlideWidth: calc(50% - var(--colPadding));

	.related-top-block {
		display: flex;
		align-items: center;
		justify-content: space-between;
		flex-wrap: wrap;
		gap: var(--colPadding);
	}

	.slider-icons-blok {
		display: flex;
		align-items: center;
		gap: var(--sliderIconsDistance);
	}

	.slider-icon {
		font-size: var(--sliderIconSize);
		will-change: transform;
		transition: transform var(--trTime) ease-out;
		cursor: pointer;
	}

	.slider-block {
		margin-top: var(--relatedTopBottomContentDistance);
	}

	.swiper {
		display: flex;
		height: 100%;
	}

	.swiper-wrapper {
		height: unset !important;
	}

	.swiper-slide {
		width: var(--swiperSlideWidth);
		margin-right: var(--gutter);

		&:last-child {
			margin-right: 0 !important;
		}
	}

	.swiper-button-disabled {
		pointer-events: none;
		cursor: default;
	}

	@media (pointer: fine) {
		@media (hover: hover) {
			.slider-icon {
				&:hover {
					transform: scale(1.2);
				}
			}
		}
	}

	/* //! 1920 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeXLMin}) {
		--relatedTopBottomContentDistance: var(--sp6x);
		--sliderIconSize: var(--sp4x);
	}

	/* //! 1536 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeLMin}) {
	}

	/* //! 1366 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeMMin}) {
		--relatedTopBottomContentDistance: var(--sp4x);
	}

	/* //! 1280 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeSMin}) {
	}

	/* //! 768 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeMin}) {
		--sliderIconSize: var(--sp3x);
	}

	/* //! Mobile */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeSMin}) {
		--swiperSlideWidth: 100%;
	}
`;
export default RelatedStyle;
